// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

const application = Application.start();

application.debug = false;
window.Stimulus = application;

const context = require.context("./controllers", true, /\.js$/);
application.load(definitionsFromContext(context));
